import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { EMPTY } from 'rxjs';
// Component
import { CompanyService, ICompanyReturn } from '../../core/company/company.service';
import { TRole, USER_ROLE } from '../auth/auth.interface';
import { AuthStore } from '../auth/auth.store';
// import { StorageService } from '../storage/storage.service';
import { ROUTER_TOKENS } from '../../app.routes';

const SERVER_PATH = import.meta.env.NG_APP_API_URL;

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private http = inject(HttpClient);
  private companyService = inject(CompanyService);
  private authStore = inject(AuthStore);

  // private storageService = inject(StorageService);

  conditionsIsSelf(id: string) {
    return id === this.authStore.userSystem?.id;
  }

  getUserDetail(userRole: TRole | undefined, userId: string | null | undefined) {
    return this.http.get(`${SERVER_PATH}/user/${userRole}/${userId}`);
  }

  getRoleDetail(role: TRole, id: string | null | undefined) {
    // const bizId = this.companyService.getBizState();
    switch (role) {
      case USER_ROLE.SUPER_ADMIN:
        return this.http.get(`${SERVER_PATH}/sub-role/super/${id}`);
      case USER_ROLE.ADMIN:
      case USER_ROLE.STAFF:
        //  const { id:compId } = this.companyService.getCompanyState() as ICompanyReturn
        return this.http.get(`${SERVER_PATH}/sub-role/${id}`);
      default:
        return EMPTY;
    }
  }

  updateProfile(role: TRole | undefined, body: any, id: string | null | undefined) {
    switch (role) {
      case USER_ROLE.OWNER:
        return this.http.patch(`${SERVER_PATH}/user/owner`, body);
      case USER_ROLE.SUPER_ADMIN:
      case USER_ROLE.ADMIN:
      case USER_ROLE.STAFF:
        return this.http.patch(`${SERVER_PATH}/user/${role}/${id}`, body);
      default:
        return EMPTY;
    }
  }

  conditionsPermissionByKey(key: string) {
    const { userSystemRole } = this.authStore;
    if (userSystemRole === USER_ROLE.OWNER) {
      return true;
    } else if (userSystemRole === USER_ROLE.SUPER_ADMIN) {
      const { id } = this.companyService.getCompanyState() as ICompanyReturn;
      const permissionObj = this.authStore.superAdminRole!.find((permission: any) => permission.company?.id === id);
      if (key === 'iam-create-staff') {
        // super admin can create staff always
        return true;
      } else {
        if (permissionObj) {
          return permissionObj.permissions.includes(key);
        } else {
          return false;
        }
      }
    } else if (userSystemRole === USER_ROLE.STAFF || userSystemRole === USER_ROLE.ADMIN) {
      const permissions = this.authStore.permissionAdminStaff;
      return permissions.includes(key);
    }
    return false;
  }

  convertUrlToPermissionKey(url: string) {
    let keyReturn = '';
    if (url.includes(`${ROUTER_TOKENS.COMP}/${ROUTER_TOKENS.CONTACT}`)) {
      keyReturn = 'contact-manage';
    }
    if (url.includes(`${ROUTER_TOKENS.COMP}/${ROUTER_TOKENS.CHAT_MANAGE}`)) {
      keyReturn = 'chat-manage';
    }
    if (url.includes(`${ROUTER_TOKENS.COMP}/${ROUTER_TOKENS.TEMPLATE_REPLY}`)) {
      keyReturn = 'template-reply-manage';
    }
    if (url.includes(`${ROUTER_TOKENS.COMP}/${ROUTER_TOKENS.CHATBOT}`)) {
      keyReturn = 'chatbot-manage';
    }
    if (url.includes(`${ROUTER_TOKENS.COMP}/${ROUTER_TOKENS.BROADCAST}`)) {
      keyReturn = 'broadcast-manage';
    }
    if (url.includes(`${ROUTER_TOKENS.COMP}/${ROUTER_TOKENS.USER}`)) {
      keyReturn = 'management-manage';
      if (url.includes(`${ROUTER_TOKENS.COMP}/${ROUTER_TOKENS.USER}/${ROUTER_TOKENS.USER_MANAGEMENT}/manage`)) {
        keyReturn = 'iam-create-staff';
      }
    }
    if (url.includes(`${ROUTER_TOKENS.COMP}/${ROUTER_TOKENS.DELIVERY}`)) {
      keyReturn = 'delivery-manage';
    }
    if (url.includes(`${ROUTER_TOKENS.COMP}/${ROUTER_TOKENS.ECOMMERCE}`)) {
      keyReturn = 'commerce-manage';
    }

    return keyReturn;
  }

  manageImageEmpty(name: string) {
    let firstWord = name[0];
    // NOTE  Ascii Code
    // 3585 = ก
    // 3630 = ฮ
    // 3631 = ฯ (เริ่มต้นสระ)
    // 3675 = ๛ (สิ้นสุดสระและตัวเลขไทย)
    if (name.charCodeAt(0) >= 3585 && name.charCodeAt(0) <= 3675) {
      for (let i = 0; i < name.length; i++) {
        if (name.charCodeAt(i) <= 3631) {
          firstWord = name[i];
          return firstWord;
        }
      }
    }

    return firstWord.toUpperCase();
  }
}
